<template>
  <v-chip
    :style="pillStyle"
    variant="flat"
    size="small"
    class="status-pill"
    :class="{ pulse: isProcessing }"
  >
    <template v-if="isProcessing">
      <v-progress-circular
        indeterminate
        size="12"
        width="2"
        color="white"
        class="mr-2"
      />
      {{ text }}
    </template>

    <template v-else>
      {{ text }}
    </template>
  </v-chip>
</template>

<script>
export default {
  name: "StatusPill",
  props: {
    text: {
      type: String,
      default: ""
    },
    backgroundColor: {
      type: String,
      default: "#37474f"
    },
    isProcessing: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    pillStyle() {
      return {
        backgroundColor: this.backgroundColor,
        color: "#ffffff",
        fontWeight: "500",
        padding: "4px 12px",
        borderRadius: "9999px",
        fontSize: "0.8rem",
        letterSpacing: "0.5px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px"
      };
    }
  }
}
</script>

<style scoped>
.pulse {
  animation: pulse 1.5s infinite ease-in-out;
}

@keyframes pulse {
  0%, 100% {
    box-shadow: 0 0 0px rgba(255, 179, 0, 0.3);
  }
  50% {
    box-shadow: 0 0 8px rgba(255, 179, 0, 0.6);
  }
}
</style>